import {
  APIError,
  customFetch,
  ErrorMessage,
  FetchParams,
  DEFAULT_API_URL,
  mergeTraceHeaders,
} from '../../common';

export type GetProductByStyleColorParams = {
  marketplace: string;
  language: string;
  consumerChannelId: string;
  styleColor: string;
} & FetchParams;

export const getProductByStyleColor = async ({
  fetchFn,
  params,
}: {
  fetchFn: typeof fetch;
  params: GetProductByStyleColorParams;
}): Promise<Record<string, unknown>> => {
  const {
    marketplace,
    language,
    consumerChannelId,
    styleColor,
    callerId,
    fetchParams: { timeout, baseUrl = DEFAULT_API_URL } = {},
    resource,
    traceHeaders,
  } = params;

  const path = `discover/product_details/v1/marketplace/${marketplace}/language/${language}/consumerChannelId/${consumerChannelId}/productCode/${styleColor}`;
  const url = `${baseUrl}/${path}`;

  const baseHeaders: Record<string, string> = callerId
    ? { 'nike-api-caller-id': callerId }
    : {};

  const requestOptions = {
    headers: mergeTraceHeaders(baseHeaders, traceHeaders),
    method: 'GET',
    path,
    timeout,
  };

  const result = await customFetch({
    fetchFn,
    options: requestOptions,
    resource,
    url,
  });

  try {
    return await result.json();
  } catch (e) {
    throw new APIError(ErrorMessage.JSON_PARSE, {
      originalMessage: e.message,
      requestOptions,
      url,
    });
  }
};
